import { NotificationTypes, isNotificationType } from './notification'

/** The `data` keys a search looks in, per type: who it is about and the service or event. */
const SEARCH_FIELDS: Record<NotificationTypes, readonly string[]> = {
  [NotificationTypes.ClientReservationCreated]: ['bookerFirstName', 'bookerLastName', 'bookerEmail', 'activityName'],
  [NotificationTypes.ClientReservationCancelled]: ['bookerFirstName', 'bookerLastName', 'bookerEmail', 'activityName'],
  [NotificationTypes.ClientJoinEvent]: ['customerFirstName', 'customerLastName', 'customerEmail', 'name'],
  [NotificationTypes.ClientEventCancelled]: ['customerFirstName', 'customerLastName', 'customerEmail', 'name'],
  [NotificationTypes.PlanLimitPublicRefusal]: ['what'],
  [NotificationTypes.CustomerJoinedEntity]: ['firstName', 'lastName'],
}

/**
 * Lower case, without diacritics, single spaces: "Ján Nováková" and "jan novakova" compare equal. The search query
 * goes through the same function as the text it is matched against.
 */
export function normalizeSearch(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace(/\s+/g, ' ').trim()
}

/**
 * The text a notification is found by in the browser's search (docs/notifications.md, _The list_). A row without a
 * type is found by its stored title and description; a type with a missing field (an older row) skips it.
 */
export function notificationSearchText(row: {
  type: string | null
  data: unknown
  title?: string
  description?: string
}): string {
  const parts = isNotificationType(row.type)
    ? SEARCH_FIELDS[row.type].map((key) => (row.data as Record<string, unknown> | null)?.[key])
    : [row.title, row.description]
  return normalizeSearch(parts.filter((part): part is string => typeof part === 'string').join(' '))
}
